import Link from 'next/link';

import { Image } from '../image';
import { Text } from '../text';

import * as styles from './index.css';

import type { Article } from '~/lib/queries';

import { Box } from '~/components/box';
import { formatDate } from '~/utils';

export const ArticleCard = ({ title, slug, featuredImage, snippet, datePublished }: Article) => (
  <Link href={`/blog/${slug.current}`}>
    <Box display="flex" flexDirection="column" justifyContent="stretch" gap="1" className={styles.card}>
      <Box position="relative" className={styles.image}>
        <Image {...featuredImage} fill />
      </Box>
      <Box flexGrow={1} paddingX="1" display="flex" flexDirection="column" justifyContent="flex-start" gap="0.5">
        <Text variant="h3">{title}</Text>
        <Text color="grey" variant="body" className={styles.snippet}>
          {snippet}
        </Text>
        <Box flexGrow={1} />
        <Text color="grey" variant="body">
          {datePublished && formatDate(datePublished, 'd MMMM yyyy')}
        </Text>
      </Box>
    </Box>
  </Link>
);
